import { defineComponent as _defineComponent } from 'vue'
import VsCard from '@/components/vision/VsCard.vue'
import VsWrapper from '@/components/vision/VsWrapper.vue'
import VsText from '@/components/vision/VsText.vue'
import VsButton from '@/components/vision/VsButton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AttachmentCard',
  props: {
    primaryText: { default: null },
    secondaryText: { default: null },
    icon: { default: 'mdi-paperclip' },
    canDelete: { type: Boolean, default: false }
  },
  setup(__props: any) {



return { __sfc: true,VsCard, VsWrapper, VsText, VsButton }
}

})